import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/src/app/not-found.tsx");
